import * as React from 'react';

class RedirectPage extends React.Component {
  render() {
    return <div>redirecting...</div>;
  }
}

export default RedirectPage;
